import { Platform, Picker as rnPicker } from 'react-native';
import { Picker as nbPicker } from 'native-base';
export default Platform.OS == 'ios' ? nbPicker : rnPicker;
